export interface AuthError {
  key: string;
  message: string;
}

export const AuthErrorsTypes = {
  EMAIL_EXISTS: 'EMAIL_EXISTS',
  UNHANDLED_ERROR: 'UNHANDLED_ERROR',
  EMAIL_NOT_FOUND: 'EMAIL_NOT_FOUND',
  INVALID_LOGIN_CREDENTIALS: 'INVALID_LOGIN_CREDENTIALS',
  EMAIL_NOT_VERIFIED: 'EMAIL_NOT_VERIFIED',
  MISSING_ROLES: 'MISSING_ROLES',
  MISSING_SUBDOMAIN: 'MISSING_SUBDOMAIN',
  MISSING_ORGANIZATION: 'MISSING_ORGANIZATION',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  SIGN_IN_METHOD_FORBIDDEN: 'SIGN_IN_METHOD_FORBIDDEN',
  PROVIDER_ALREADY_LINKED: 'PROVIDER_ALREADY_LINKED',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  OPERATION_NOT_ALLOWED: 'OPERATION_NOT_ALLOWED',
  ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIALS: 'ACCOUNT_EXISTS_WITH_DIFFERENT_CREDENTIALS',
};
